/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} L7_Price_P1Inputs */

const es_l7_price_p1 = /** @type {(inputs: L7_Price_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comisión plana sobre el alquiler, tarifa de gestión en precio de lanzamiento y cero cargos por el papeleo que otros facturan aparte.`)
};

const gl_l7_price_p1 = /** @type {(inputs: L7_Price_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comisión plana sobre o alugueiro, tarifa de xestión en prezo de lanzamento e cero cargos polo papel que outros facturan á parte.`)
};

const en_l7_price_p1 = /** @type {(inputs: L7_Price_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flat commission on rental, launch-price management fee and zero charges for paperwork others bill separately.`)
};

/**
* | output |
* | --- |
* | "Flat commission on rental, launch-price management fee and zero charges for paperwork others bill separately." |
*
* @param {L7_Price_P1Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const l7_price_p1 = /** @type {((inputs?: L7_Price_P1Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<L7_Price_P1Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_l7_price_p1(inputs)
	if (locale === "en") return en_l7_price_p1(inputs)
	return es_l7_price_p1(inputs)
});